export const getUserData = state => state.user.user;
export const getIsLoadingUser = state => state.user.isLoading;
export const getUserError = state => state.user.errorMessage;
